import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {SharedModule} from "../shared/shared.module";
import {CoreModule} from "../core/core.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FacturesRoutingModule} from "./factures-routing.module";
import {FacturesFournisseursComponent} from "./fournisseurs/factures/factures-fournisseurs.component";
import {FacturesRootComponent} from "./factures-root.component";
import {
    DxDataGridModule,
    DxDateBoxModule, DxLookupModule, DxNumberBoxModule,
    DxPopupModule, DxScrollViewModule,
    DxTagBoxModule,
    DxTextBoxModule,
    DxToolbarModule
} from "devextreme-angular";

import {
  DialogJoinBonReceptionComponent
} from "./fournisseurs/factures/dialog-join-bon-reception/dialog-join-bon-reception.component";
import {DialogDetailsInvoiceComponent} from "./fournisseurs/factures/dialog-details-invoice/dialog-details-invoice.component";
import {AvoirFournisseurComponent} from "./fournisseurs/avoirs/avoir-fournisseur.component";
import {AvoirFournisseurDetailsDialogComponent} from "./fournisseurs/avoirs/dialog-edition/avoir-fournisseur-details-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FacturesRoutingModule,
        SharedModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        DxDataGridModule,
        DxToolbarModule,

        DxTagBoxModule,
        DxPopupModule,
        DxDateBoxModule,
        DxTextBoxModule,
        DxScrollViewModule,
        DxLookupModule,
        DxNumberBoxModule,
    ],
  declarations: [
    FacturesRootComponent,
    FacturesFournisseursComponent,
    DialogJoinBonReceptionComponent,
    DialogDetailsInvoiceComponent,
    AvoirFournisseurComponent,
    AvoirFournisseurDetailsDialogComponent
  ]
})
export class FacturesModule { }
